import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Button, Dialog, DialogContent, Grid, IconButton, SvgIcon, TextField, Typography } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as TurnosIcon } from './../../../assets/icons/iconoTurnosGris.svg';
import { capitalize } from "../../../helpers/randoms";
import TwitterIcon from '@material-ui/icons/Twitter';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import UbicacionIcon from '../../../assets/icons/Ubicacion.png';
import CompartirIcon from '../../../assets/icons/Compartir.png';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import FavoriteIcon from '@material-ui/icons/Favorite';
import { agregarFavoritoCartilla, eliminarFavoritoCartilla } from "../../../actions/webAfiliado/cartillaMiOspedycActions";

const useStyles = makeStyles((theme) => ({
    titleItemCartilla: {
        fontWeight: "bold",
    },
    datosItemCartilla: {
        fontWeight: 500,
    },
    buttonsItemCartilla: {
        paddingTop: 0,
        paddingBottom: 5,
        paddingLeft: 5,
        paddingRight: 5
    },
    containerItemsCatilla: {
        marginTop: "2rem"
    },
    titleModalShared: {
        fontWeight: "bold",
    },
    containerModal: {
        padding: "2rem",
        paddingBottom: "3rem"
    },
    titleIconsShared: {
        fontWeight: "bold"
    },
    buttonIconsShared: {
        textTransform: "none"
    }
}));

export const ItemCartilla = ({ item }) => {

    const classes = useStyles();
    const dispatch=useDispatch()

    const { items: provincias } = useSelector(state => state.provincias);
    const { items: localidades } = useSelector(state => state.localidades);
    const { miCartilla } = useSelector((state) => state.cartillaMiOspedyc);

    const [openShared, setOpenShared] = useState(false)

    const handleCopyClipBoard = () => {
        const copyText = document.getElementById("inputForCopy");

        /* Select the text field */
        copyText.select();
        copyText.setSelectionRange(0, 99999); /* For mobile devices */

        /* Copy the text inside the text field */
        window.navigator.clipboard.writeText(copyText.value);
    }

    const domicilio = item.datosDomicilio?.direccion || item.datosCentroMedico?.direccion
    const localidad = capitalize(`${localidades.find(x => x.id_localidad === (item.datosDomicilio?.idLocalidad || item.datosCentroMedico?.idLocalidad))?.descripcion_localidad}`.toLowerCase(), true)
    const provincia = capitalize(`${provincias.find(x => x.id_provincia === (item.datosDomicilio?.idProvincia || item.datosCentroMedico?.idProvincia))?.descripcion_provincia}`.toLowerCase(), true)
    const telefono = item.datosDomicilio?.telefono || item.datosCentroMedico?.telefono

    const existeEnMiCartilla = miCartilla.map(e => e.idCartillaPrestadores).includes(item.idCartillaPrestadores)
    return (
        <React.Fragment>
            <Grid container>
                <Grid item xs={8}>
                    <Typography variant="body1" color="secondary" className={classes.titleItemCartilla}>{item.nombreCompleto}</Typography>
                    <br />
                    <br />
                    {
                        item.datosCentroMedico &&
                        <Typography variant="body2" color="secondary" className={classes.datosItemCartilla}>{item.datosCentroMedico.nombre}</Typography>
                    }
                    <Typography variant="body2" color="secondary" className={classes.datosItemCartilla}>{`${domicilio}, ${localidad}, ${provincia}`}</Typography>
                    <Typography variant="body2" color="secondary" className={classes.datosItemCartilla}>{telefono}</Typography>
                </Grid>
                <Grid item xs={4}>
                    <Grid container justify='flex-end'>
                        {
                            item.datosCentroMedico &&
                            <Grid item>
                                <IconButton
                                    onClick={() => { }}
                                    color="primary"
                                    aria-label="seleccionar"
                                    className={classes.buttonsItemCartilla}
                                >
                                    <SvgIcon fontSize="default"><TurnosIcon style={{ fill: "none" }} /></SvgIcon>
                                </IconButton>
                            </Grid>
                        }
                        <Grid item>
                            <IconButton
                                onClick={() => { }}
                                color="primary"
                                aria-label="seleccionar"
                                className={classes.buttonsItemCartilla}
                                component="a"
                                href={`https://maps.google.com/?q=${domicilio}, ${localidad}, ${provincia}`}
                                target="_blank"
                            >
                                <img src={UbicacionIcon} alt="Icon Ubicacion" />
                            </IconButton>
                        </Grid>
                        <Grid item>
                            <IconButton
                                onClick={() => setOpenShared(true)}
                                color="primary"
                                aria-label="seleccionar"
                                className={classes.buttonsItemCartilla}
                            >
                                <img src={CompartirIcon} alt="Icon Shared" />
                            </IconButton>
                        </Grid>
                        <Grid item>
                            <IconButton
                                onClick={() => {
                                    if(existeEnMiCartilla){
                                        dispatch(eliminarFavoritoCartilla(item.idCartillaPrestadores))
                                    }else{
                                        dispatch(agregarFavoritoCartilla(item.idCartillaPrestadores))
                                    }
                                 }}
                                color="primary"
                                aria-label="seleccionar"
                                className={classes.buttonsItemCartilla}
                            >
                                {
                                    existeEnMiCartilla
                                        ?
                                        <FavoriteIcon color="primary" />
                                        :
                                        <FavoriteBorderIcon color="secondary" />
                                }

                                {/* <SvgIcon fontSize="default"><TurnosIcon style={{ fill: "none" }} /></SvgIcon> */}
                            </IconButton>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Dialog fullWidth maxWidth="sm" onClose={() => setOpenShared(false)} aria-labelledby="dialog-shared" open={openShared}>
                <DialogContent className={classes.containerModal}>
                    <Typography color="primary" align="center" className={classes.titleModalShared}>Compartir a través de</Typography>
                    <br />
                    <Grid container justify="center" alignItems="center" spacing={3}>
                        <Grid item>
                            <Button className={classes.buttonIconsShared} component="a" href={`https://twitter.com/intent/tweet?text=${item.nombreCompleto} - ${domicilio}, ${localidad}, ${provincia} - ${telefono}`} target="_blank">
                                <div>
                                    <Typography align="center">
                                        <TwitterIcon color="secondary" />
                                    </Typography>
                                    <Typography className={classes.titleIconsShared} variant="body2" color="secondary">Twitter</Typography>
                                </div>
                            </Button>
                        </Grid>
                        {/* <Grid item>
                            <Button className={classes.buttonIconsShared}>
                                <div>
                                    <Typography align="center">
                                        <FacebookIcon color="secondary" />
                                    </Typography>
                                    <Typography className={classes.titleIconsShared} variant="body2" color="secondary" >Facebook</Typography>
                                </div>
                            </Button>
                        </Grid> */}
                        <Grid item>
                            <Button className={classes.buttonIconsShared} component="a" href={`https://api.whatsapp.com/send?text=${item.nombreCompleto} - ${domicilio}, ${localidad}, ${provincia} - ${telefono}`} target="_blank">
                                <div>
                                    <Typography align="center">
                                        <WhatsAppIcon color="secondary" />
                                    </Typography>
                                    <Typography className={classes.titleIconsShared} variant="body2" color="secondary">Whatsapp</Typography>
                                </div>
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button className={classes.buttonIconsShared} component="a" href={`mailto:inserte-su-corre@aqui.com?body=${item.nombreCompleto} - ${domicilio}, ${localidad}, ${provincia} - ${telefono}`} target="_blank">
                                <div>
                                    <Typography align="center">
                                        <MailOutlineIcon color="secondary" />
                                    </Typography>
                                    <Typography className={classes.titleIconsShared} variant="body2" color="secondary">Email</Typography>
                                </div>
                            </Button>
                        </Grid>
                    </Grid>

                    <br />
                    <br />
                    <TextField
                        id={"inputForCopy"}
                        defaultValue={`${item.nombreCompleto} - ${domicilio}, ${localidad}, ${provincia} - ${telefono}`}
                        fullWidth
                        focused
                    />
                    <br />
                    <br />
                    <br />
                    <Grid container justify="center">
                        <Button variant="contained" color="primary" onClick={() => handleCopyClipBoard()}>COPIAR DATOS</Button>
                    </Grid>

                </DialogContent>
            </Dialog>
        </React.Fragment >
    );
};
